import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import api from "../Utility/api";
const API = process.env.REACT_APP_API_URL || "";
export default function Register() {
  const [fields, setFields] = useState({
    username: "",
    password: "",
    email: "",
    description: "",
  });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const update = (event) =>
    setFields((current) => ({
      ...current,
      [event.target.name]: event.target.value,
    }));
  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post(`${API}/api/register`, {
        ...fields,
        username: fields.username.trim(),
        email: fields.email.trim(),
      });
      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.error || "Unable to create an account.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Container maxWidth="sm" sx={{ pt: { xs: 4, sm: 7 } }}>
      <Paper elevation={6} sx={{ p: { xs: 3, sm: 5 } }}>
        <span className="eyebrow">A place for your imagination</span>
        <Typography variant="h4" component="h1" mb={1}>
          Begin your story.
        </Typography>
        <Typography color="text.secondary" mb={3}>
          Create a free account to write and share your adventures.
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Box component="form" onSubmit={submit}>
          <Stack gap={2.5}>
            <TextField
              name="username"
              label="Username"
              autoComplete="username"
              inputProps={{
                autoCapitalize: "none",
                autoCorrect: "off",
                spellCheck: false,
                maxLength: 80,
              }}
              value={fields.username}
              onChange={update}
              required
              fullWidth
            />
            <TextField
              name="email"
              label="Email"
              type="email"
              autoComplete="email"
              value={fields.email}
              onChange={update}
              required
              fullWidth
            />
            <TextField
              name="password"
              label="Password"
              type="password"
              autoComplete="new-password"
              value={fields.password}
              onChange={update}
              required
              fullWidth
            />
            <TextField
              name="description"
              label="A little about you (optional)"
              multiline
              minRows={2}
              value={fields.description}
              onChange={update}
              fullWidth
            />
            <Button
              type="submit"
              variant="contained"
              disabled={busy}
              size="large"
            >
              {busy ? "Creating account…" : "Create account"}
            </Button>
          </Stack>
        </Box>
        <Typography mt={3} variant="body2">
          Already a storyteller here? <Link to="/login">Sign in</Link>
        </Typography>
      </Paper>
    </Container>
  );
}
